import {GET_DATA_PLANHANDLE_PLANHANDLE, SET_DATA_PLANHANDLE_PLANHANDLE} from '../actions/actionTypes'
import {RequertPlanHandlePlanHandleFaileAction, GetDataPlanHandlePlanHandleSuccessAction, IsResultAction } from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'

function* GetDataPlanHandle(action){
    try{
        const DataPlanHandle = yield Api.GetDataPlanHandleFromApi(action.DataPlanHandle);
        yield put(GetDataPlanHandlePlanHandleSuccessAction(DataPlanHandle))
    }catch(error){
        yield put(RequertPlanHandlePlanHandleFaileAction(error))
    }
}
export function* watchGetDataPlanHandle(){
    yield takeLatest(GET_DATA_PLANHANDLE_PLANHANDLE, GetDataPlanHandle)
}

function* SetDataPlanHandle(action){
    try{
        const isResult = yield Api.SetDataPlanHandleFromApi(action.DataPlanHandle);
        yield put(IsResultAction(isResult))
    }catch(error){
        yield put(RequertPlanHandlePlanHandleFaileAction(error))
    }
}
export function* watchSetDataPlanHandle(){
    yield takeLatest(SET_DATA_PLANHANDLE_PLANHANDLE, SetDataPlanHandle)
}